module.exports = __webpack_public_path__ + "static/img/logo_black.68db42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black.png
// module id = q3zs
// module chunks = 18